document.documentElement.classList.remove('no-js');

document.addEventListener('submit', async function(event) {
  const form = event.target;
  if (!form.matches('.vc-quick-form')) return;

  event.preventDefault();
  const button = form.querySelector('button');
  if (button) {
    button.disabled = true;
    button.textContent = 'Adding…';
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Accept': 'application/json'},
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Unable to add item');
    await response.json();

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

    if (button) button.textContent = 'Added';
    setTimeout(() => {
      if (button) {
        button.disabled = false;
        button.textContent = 'Add';
      }
    }, 1200);
  } catch (error) {
    if (button) {
      button.disabled = false;
      button.textContent = 'Try again';
    }
  }
});
